import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './services/httpClient'

import Sprite from '@/components/core/Sprite'
import CBtn from '@/components/core/ui/CBtn'
import Image from '@/components/core/Image'

import { VueMaskDirective } from './services/v-mask'
import { Affix } from 'vue-affix'
import VueClickAway from 'vue3-click-away'
import Vue3TouchEvents from 'vue3-touch-events'

import Date from './services/dayjs'
import 'vue-toastification/dist/index.css'

import 'swiper/swiper.scss'
import '@/assets/styles/app.scss'

import svgForEverybody from 'svg4everybody'
import { createGtm } from '@gtm-support/vue-gtm'
import Cookies from '@/services/cookies'
import analytics from '@/mixins/analytics'
import blockView from '@/mixins/blockView'
import { initializeApp } from 'firebase/app'
import { getPerformance } from 'firebase/performance'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

// Plugins
import numFunctionsPlugin from '@/plugins/numFunctionsPlugin'
import deviceDetector from '@/plugins/deviceDetector'
import toastPlugin from '@/plugins/toastPlugin'
import isImage from '@/plugins/isImage'

export const app = createApp(App)
  .use(store)
  .use(router)
/* Конструкции */
app.use(VueClickAway)
app.use(Date)
const gtm = createGtm({
  id: 'GTM-PZ4B65',
  defer: true,
  loadScript: true,
  debug: Cookies.get('gtm_debug') ? Cookies.get('gtm_debug') : false, // Whether or not display console logs debugs (optional)
})
app.use(gtm)

/* Плагины */
app.use(numFunctionsPlugin)
app.use(deviceDetector)
app.use(toastPlugin)
app.use(isImage)

app.use(Vue3TouchEvents)
/* Директивы */
app.directive('mask', VueMaskDirective)

/* Компоненты */
app.component('Sprite', Sprite)
app.component('Image', Image)
app.component('CBtn', CBtn)
app.component('Affix', Affix)

/* Миксины */
app.mixin(analytics)
app.mixin(blockView)

Sentry.init({
  app,
  dsn: 'https://113651e078d5b542d19f5273d877924b@sentry.growfood.pro/2',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
})

app.mount('#app')

// Collect all SVGs
function requireAll (r) {
  r.keys().forEach(r)
}
requireAll(require.context('./assets/sprites/', true, /\.(svg)$/))

export const svgHash = Math.random()
svgForEverybody()

// firebase
const firebaseConfig = {
  apiKey: 'AIzaSyChB3Hfr_4IPcWXzifu4GyTEd_AoRwNRV0',
  authDomain: 'gf-web-3d420.firebaseapp.com',
  projectId: 'gf-web-3d420',
  storageBucket: 'gf-web-3d420.appspot.com',
  messagingSenderId: '784233279762',
  appId: '1:784233279762:web:79950e986b81ac132943cb',
}
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)
export const firebasePerformance = getPerformance(firebaseApp)
